module.exports = __webpack_public_path__ + "media/assets/faria_products/Attendance-e13e994761fe766e56a7feee910a565781ada0714c04e59fc961d0d8d6f00b44.png";